import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from './baseQueryWithReauth';

export interface Category {
  id: string;
  name: string;
  description?: string;
  parent_id?: string | null;
}

export interface MarketplaceService {
  id: string;
  name: string;
  description?: string;
  category?: string;
  base_price?: number;
  expected_install_time_days?: number;
  validation_days_estimate?: number;
  expected_availability_time_hours?: number;
  expected_contract_hours?: number;
  metadata?: any;
  pricing?: any;
  average_rating?: number;
  review_count?: number;
}

export const marketplaceApi = createApi({
  reducerPath: 'marketplaceApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Category', 'MarketplaceService'],
  endpoints: (builder) => ({
    getCategories: builder.query<Category[], void>({
      query: () => ({ url: '/marketplace/categories' }),
      providesTags: ['Category'],
    }),
    createCategory: builder.mutation<Category, Partial<Category>>({
      query: (body) => ({
        url: '/marketplace/categories',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Category'],
    }),
    updateCategory: builder.mutation<Category, { id: string; data: Partial<Category> }>({
      query: ({ id, data }) => ({
        url: `/marketplace/categories/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Category'],
    }),
    getMarketplaceService: builder.query<MarketplaceService, string>({
      query: (id) => ({ url: `/marketplace/services/${id}` }),
      providesTags: (_result, _error, id) => [{ type: 'MarketplaceService', id }],
    }),
  }),
});

export const {
  useGetCategoriesQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useGetMarketplaceServiceQuery,
} = marketplaceApi;
